import {USER_ROLES} from "../generalConstants";

export default class UserAsset {
  constructor(user) {
    this.userRole = user?.role?.roleId;
  }

  get isSuperUser() {
    return this.userRole === USER_ROLES.SUPER_USER;
  }
  get isTopManager() {
    return this.userRole === USER_ROLES.TOP_MANAGER;
  }
}
